var map = {
	"./abkhazia.svg": 84,
	"./afghanistan.svg": 85,
	"./aland-islands.svg": 86,
	"./albania.svg": 87,
	"./algeria.svg": 88,
	"./american-samoa.svg": 89,
	"./andorra.svg": 90,
	"./angola.svg": 91,
	"./anguilla.svg": 92,
	"./antigua-and-barbuda.svg": 93,
	"./argentina.svg": 94,
	"./armenia.svg": 95,
	"./aruba.svg": 96,
	"./australia.svg": 97,
	"./austria.svg": 98,
	"./azerbaijan.svg": 99,
	"./azores-islands.svg": 100,
	"./bahamas.svg": 101,
	"./bahrain.svg": 102,
	"./balearic-islands.svg": 103,
	"./bangladesh.svg": 104,
	"./barbados.svg": 105,
	"./basque-country.svg": 106,
	"./belarus.svg": 107,
	"./belgium.svg": 108,
	"./belize.svg": 109,
	"./benin.svg": 110,
	"./bermuda.svg": 111,
	"./bhutan.svg": 112,
	"./bolivia.svg": 113,
	"./bonaire.svg": 114,
	"./bosnia-and-herzegovina.svg": 115,
	"./botswana.svg": 116,
	"./brazil.svg": 117,
	"./british-columbia.svg": 118,
	"./british-indian-ocean-territory.svg": 119,
	"./british-virgin-islands.svg": 120,
	"./brunei.svg": 121,
	"./bulgaria.svg": 122,
	"./burkina-faso.svg": 123,
	"./burundi.svg": 124,
	"./cambodia.svg": 125,
	"./cameroon.svg": 126,
	"./canada.svg": 127,
	"./canary-islands.svg": 128,
	"./cape-verde.svg": 129,
	"./cayman-islands.svg": 130,
	"./central-african-republic.svg": 131,
	"./ceuta.svg": 132,
	"./chad.svg": 133,
	"./chile.svg": 134,
	"./china.svg": 135,
	"./christmas-island.svg": 136,
	"./cocos-island.svg": 137,
	"./colombia.svg": 138,
	"./comoros.svg": 139,
	"./cook-islands.svg": 140,
	"./corsica.svg": 141,
	"./costa-rica.svg": 142,
	"./croatia.svg": 143,
	"./cuba.svg": 144,
	"./curacao.svg": 145,
	"./cyprus.svg": 146,
	"./czech-republic.svg": 147,
	"./democratic-republic-of-congo.svg": 148,
	"./denmark.svg": 149,
	"./djibouti.svg": 150,
	"./dominica.svg": 151,
	"./dominican-republic.svg": 152,
	"./east-timor.svg": 153,
	"./ecuador.svg": 154,
	"./egypt.svg": 155,
	"./el-salvador.svg": 156,
	"./england.svg": 157,
	"./equatorial-guinea.svg": 158,
	"./eritrea.svg": 159,
	"./estonia.svg": 160,
	"./ethiopia.svg": 161,
	"./european-union.svg": 162,
	"./falkland-islands.svg": 163,
	"./faroe-islands.svg": 164,
	"./fiji.svg": 165,
	"./finland.svg": 166,
	"./france.svg": 167,
	"./french-polynesia.svg": 168,
	"./gabon.svg": 169,
	"./galapagos-islands.svg": 170,
	"./gambia.svg": 171,
	"./georgia.svg": 172,
	"./germany.svg": 173,
	"./ghana.svg": 174,
	"./gibraltar.svg": 175,
	"./greece.svg": 176,
	"./greenland.svg": 177,
	"./grenada.svg": 178,
	"./guam.svg": 179,
	"./guatemala.svg": 180,
	"./guernsey.svg": 181,
	"./guinea-bissau.svg": 182,
	"./guinea.svg": 183,
	"./haiti.svg": 184,
	"./hawaii.svg": 185,
	"./honduras.svg": 186,
	"./hong-kong.svg": 187,
	"./hungary.svg": 188,
	"./iceland.svg": 189,
	"./india.svg": 190,
	"./indonesia.svg": 191,
	"./iran.svg": 192,
	"./iraq.svg": 193,
	"./ireland.svg": 194,
	"./isle-of-man.svg": 195,
	"./israel.svg": 196,
	"./italy.svg": 197,
	"./ivory-coast.svg": 198,
	"./jamaica.svg": 199,
	"./japan.svg": 200,
	"./jersey.svg": 201,
	"./jordan.svg": 202,
	"./kazakhstan.svg": 203,
	"./kenya.svg": 204,
	"./kiribati.svg": 205,
	"./kosovo.svg": 206,
	"./kuwait.svg": 207,
	"./kyrgyzstan.svg": 208,
	"./laos.svg": 209,
	"./latvia.svg": 210,
	"./lebanon.svg": 211,
	"./lesotho.svg": 212,
	"./liberia.svg": 213,
	"./libya.svg": 214,
	"./liechtenstein.svg": 215,
	"./lithuania.svg": 216,
	"./luxembourg.svg": 217,
	"./macao.svg": 218,
	"./madagascar.svg": 219,
	"./madeira.svg": 220,
	"./malawi.svg": 221,
	"./malaysia.svg": 222,
	"./maldives.svg": 223,
	"./mali.svg": 224,
	"./malta.svg": 225,
	"./marshall-island.svg": 226,
	"./martinique.svg": 227,
	"./mauritania.svg": 228,
	"./mauritius.svg": 229,
	"./melilla.svg": 230,
	"./mexico.svg": 231,
	"./micronesia.svg": 232,
	"./moldova.svg": 233,
	"./monaco.svg": 234,
	"./mongolia.svg": 235,
	"./montenegro.svg": 236,
	"./montserrat.svg": 237,
	"./morocco.svg": 238,
	"./mozambique.svg": 239,
	"./myanmar.svg": 240,
	"./namibia.svg": 241,
	"./nato.svg": 242,
	"./nauru.svg": 243,
	"./nepal.svg": 244,
	"./netherlands.svg": 245,
	"./new-zealand.svg": 246,
	"./nicaragua.svg": 247,
	"./niger.svg": 248,
	"./nigeria.svg": 249,
	"./niue.svg": 250,
	"./norfolk-island.svg": 251,
	"./north-korea.svg": 252,
	"./northern-cyprus.svg": 253,
	"./northern-marianas-islands.svg": 254,
	"./norway.svg": 255,
	"./oman.svg": 256,
	"./orkney-islands.svg": 257,
	"./ossetia.svg": 258,
	"./pakistan.svg": 259,
	"./palau.svg": 260,
	"./palestine.svg": 261,
	"./panama.svg": 262,
	"./papua-new-guinea.svg": 263,
	"./paraguay.svg": 264,
	"./peru.svg": 265,
	"./philippines.svg": 266,
	"./pitcairn-islands.svg": 267,
	"./poland.svg": 268,
	"./portugal.svg": 269,
	"./puerto-rico.svg": 270,
	"./qatar.svg": 271,
	"./rapa-nui.svg": 272,
	"./republic-of-macedonia.svg": 273,
	"./republic-of-the-congo.svg": 274,
	"./romania.svg": 275,
	"./russia.svg": 276,
	"./rwanda.svg": 277,
	"./saba-island.svg": 278,
	"./sahrawi-arab-democratic-republic.svg": 279,
	"./saint-kitts-and-nevis.svg": 280,
	"./samoa.svg": 281,
	"./san-marino.svg": 282,
	"./sao-tome-and-prince.svg": 283,
	"./sardinia.svg": 284,
	"./saudi-arabia.svg": 285,
	"./scotland.svg": 286,
	"./senegal.svg": 287,
	"./serbia.svg": 288,
	"./seychelles.svg": 289,
	"./sierra-leone.svg": 290,
	"./singapore.svg": 291,
	"./sint-eustatius.svg": 292,
	"./sint-maarten.svg": 293,
	"./slovakia.svg": 294,
	"./slovenia.svg": 295,
	"./solomon-islands.svg": 296,
	"./somalia.svg": 297,
	"./somaliland.svg": 298,
	"./south-africa.svg": 299,
	"./south-korea.svg": 300,
	"./south-sudan.svg": 301,
	"./spain.svg": 302,
	"./sri-lanka.svg": 303,
	"./st-barts.svg": 304,
	"./st-lucia.svg": 305,
	"./st-vincent-and-the-grenadines.svg": 306,
	"./sudan.svg": 307,
	"./suriname.svg": 308,
	"./swaziland.svg": 309,
	"./sweden.svg": 310,
	"./switzerland.svg": 311,
	"./syria.svg": 312,
	"./taiwan.svg": 313,
	"./tajikistan.svg": 314,
	"./tanzania.svg": 315,
	"./thailand.svg": 316,
	"./tibet.svg": 317,
	"./togo.svg": 318,
	"./tokelau.svg": 319,
	"./tonga.svg": 320,
	"./transnistria.svg": 321,
	"./trinidad-and-tobago.svg": 322,
	"./tunisia.svg": 323,
	"./turkey.svg": 324,
	"./turkmenistan.svg": 325,
	"./turks-and-caicos.svg": 326,
	"./tuvalu.svg": 327,
	"./uganda.svg": 328,
	"./ukraine.svg": 329,
	"./united-arab-emirates.svg": 330,
	"./united-kingdom.svg": 331,
	"./united-nations.svg": 332,
	"./united-states.svg": 333,
	"./uruguay.svg": 334,
	"./uzbekistan.svg": 335,
	"./vanuatu.svg": 336,
	"./vatican-city.svg": 337,
	"./venezuela.svg": 338,
	"./vietnam.svg": 339,
	"./virgin-islands.svg": 340,
	"./wales.svg": 341,
	"./yemen.svg": 342,
	"./zambia.svg": 343,
	"./zimbabwe.svg": 344
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg nonrecursive \.svg$
// module id = 57
// module chunks = 10